module.exports = __webpack_public_path__ + "img/ic_checker_hanging.4195088d.svg";